import "../components/global.js";
import "../assets/css/bootstrap.css";
import Navbar from "../components/Navbar";
import Select from "react-select";
import Swal from "sweetalert2";
import { 
  loading, tokens, select_style, alert, success, alert_url, toFixed, 
  GET, POST, PUT, DELETE, format_date, float, DatePicker, 
  getStorage, roundToTwo, fieldSorter, total, success_url 
} from "../components/CustomComponent.js";
import React, { Component } from "react";
import { ReactExcel, readFile, generateObjects } from "@ramonak/react-excel";
import excel_file from "../assets/files/TemplateBookbank.xlsx";
import Tesseract from "tesseract.js";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { Modal } from "react-bootstrap";

import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import pdfjsWorker from "pdfjs-dist/legacy/build/pdf.worker.entry";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const role = getStorage("role_detail");
const select_role = role ? role.find((item) => item.name === "record-water-usage") : null;
const view_r = select_role && select_role.role[0] === 1;
const create_r = select_role && select_role.role[1] === 1;

export default class RecordWaterUsage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_date: format_date(new Date(), "yyyy-mm", "en"),
      data_statement: [],
      data_bookbank: [],
      data_bookbank_remove: [],
      data_iw: [],
      start_date_statement: "",
      start_balance_statement: 0,
      last_balance_statement: 0,
      total_forward: 0,
      select_bookbank: -1,
      currentSheet_current: null,
      import_current: null,
      data_import_current: [],
      save: true,
      disabled: false,
      draggedIndex: null,
      tab1: true,
      tab2: true,
      tab3: false,
      balance_forward: 0,
      modal_remark: false,
      remark: "",
      bookbank_index: -1,
    };
    this.inputRefs = [];
    this.timeRefs = [];
    this.tableRefAll = React.createRef();
    this.tableRefSome = React.createRef();
    this.tableRefBookBank = React.createRef();
  }

  async componentDidMount() {
    loading(false); // ปิด loading ตั้งแต่เข้ามาหน้าครั้งแรก
    if (view_r) {
      this.Get();
    }
    setTimeout(() => this.inputRefs[1]?.focus(), 100);
  }

  Get = async () => {
    loading(true);
    let filterDate0 = format_date(new Date(new Date(this.state.filter_date).setDate(0)), "yyyy-mm-dd", "en");
    let filterDate1 = format_date(new Date(new Date(this.state.filter_date).setDate(1)), "yyyy-mm-dd", "en");
    let filterDateEnd = format_date(new Date(new Date(new Date(new Date(this.state.filter_date).setDate(1)).setMonth(new Date(this.state.filter_date).getMonth() + 1)).setDate(0)), "yyyy-mm-dd", "en");

    let body_last = { page: 0, start_date: filterDate0, end_date: filterDate0 };
    let body = { page: 0, start_date: filterDate1, end_date: filterDateEnd };

    let [result_last, result_setting] = await Promise.all([
      GET(tokens, "v1/TH/statement/daily-reconcile/list/" + getStorage("project_id"), body_last),
      GET(tokens, "v1/TH/water-manage/detail/" + getStorage("water_id"), null)
    ]);

    let [result_daily, result_bookbank, result_iw] = await Promise.all([
      GET(tokens, "v1/TH/statement/daily-reconcile/list/" + getStorage("project_id"), body),
      GET(tokens, "v1/TH/statement/list/" + getStorage("project_id"), body),
      GET(tokens, "v1/TH/record-receipt/statement/" + getStorage("project_id"), body)
    ]);

    let data_bookbank = result_bookbank?.data?.data || [];
    let start_date_statement = result_setting?.data?.data?.start_date_statement;
    let start_balance_statement = result_setting?.data?.data?.start_balance_statement;
    let last_balance_statement = result_last[0]?.data?.data?.total_forward || 0;
    
    let isSameMonth = format_date(start_date_statement, "yyyy-mm") === format_date(this.state.filter_date, "yyyy-mm");
    let balance_forward = isSameMonth ? start_balance_statement : (data_bookbank.length === 0 ? last_balance_statement : start_balance_statement);

    let iw = result_iw?.data?.data || [];
    let sorted_iw = [];
    for (let item of data_bookbank) {
      let index = iw.findIndex((e) => e.iw_number === item.iw_number);
      if (index !== -1) {
        sorted_iw.push(iw[index]);
        iw = iw.filter((e, i) => i !== index);
      } else {
        sorted_iw.push({ total_final: 0, transfer_time: "" });
      }
    }
    sorted_iw = [...sorted_iw, ...iw];

    this.setState({
      data_bookbank: data_bookbank.sort(fieldSorter(["date", "time"])),
      data_iw: sorted_iw,
      start_date_statement,
      start_balance_statement,
      last_balance_statement,
      balance_forward: isSameMonth ? start_balance_statement : (data_bookbank.length === 0 ? last_balance_statement : data_bookbank[data_bookbank.length - 1]?.balance),
    });
    loading(false);
  };

  updateBalances = (newBookbank = this.state.data_bookbank) => {
    let { start_date_statement, filter_date, start_balance_statement, last_balance_statement } = this.state;
    let isSameMonth = format_date(start_date_statement, "yyyy-mm") === format_date(filter_date, "yyyy-mm");

    newBookbank.forEach((item, j) => {
      let prevBalance = j === 0 
        ? (isSameMonth ? start_balance_statement : last_balance_statement) 
        : newBookbank[j - 1].balance;
      item.balance = Number(prevBalance) + (Number(item.income) - Number(item.outcome));
    });
    return newBookbank;
  };

  getNewRow = () => ({
    date: this.state.select_date || "",
    time: "",
    income: 0,
    outcome: 0,
    balance: 0,
    iw_number: "",
    status: "2",
    remark: "",
    record_name: [{
      name: getStorage("full_name"),
      status: "2",
      record_time: format_date(new Date(), "yyyy-mm-dd", "en"),
    }],
  });

  CreateUpdate = async () => {
    if (this.state.data_bookbank.some((e) => !e.date)) {
      alert("warning", "แจ้งเตือน", "กรุณาเลือกวันที่ให้ครบทั้งหมด");
      return;
    }
    
    let diff_anount = this.state.data_bookbank.reduce((acc, item) => {
      let iw = this.state.data_iw.find((e) => e.iw_number === item.iw_number);
      return (iw && Number(iw.total_final || 0) !== Number(item.income || 0)) ? acc + 1 : acc;
    }, 0);

    let data_alert = {
      date: this.state.filter_date,
      waiting_receipt_amount: this.state.data_bookbank.filter((e) => e.status == "3").length,
      receipt_more_transfer_amount: this.state.data_iw.filter((e) => new Date(e.record_date).getTime() - new Date(e.transfer_date).getTime() > 3 * 24 * 60 * 60 * 1000).length,
      waiting_amount: this.state.data_iw.filter((item) => !this.state.data_bookbank.map((e) => e.iw_number).includes(item.iw_number)).length,
      diff_anount,
      total_forward: this.state.data_bookbank.length === 0 ? Number(this.state.balance_forward) : Number(this.state.data_bookbank[this.state.data_bookbank.length - 1]?.balance || 0),
    };

    Swal.fire({
      icon: "info",
      title: "ยืนยันการบันทึกข้อมูล",
      html: `
        <div class="text-left">
        <div class="d-flex justify-content-center"><div class="wpx-180">วันที่ทำการบันทึก</div><div class="wpx-100">${format_date(data_alert.date, "mm/yyyy")}</div></div>
        <div class="d-flex justify-content-center"><div class="wpx-180">จำนวนที่รอออกใบเสร็จ</div><div class="wpx-100">${data_alert.waiting_receipt_amount}</div></div>
        <div class="d-flex justify-content-center"><div class="wpx-180">จำนวนที่ใบเสร็จมากกว่าวันที่โอน</div><div class="wpx-100">${data_alert.receipt_more_transfer_amount}</div></div>
        <div class="d-flex justify-content-center"><div class="wpx-180">จำนวนที่รอยอดเงินโอน</div><div class="wpx-100">${data_alert.waiting_amount}</div></div>
        <div class="d-flex justify-content-center"><div class="wpx-180">จำนวนที่ไม่ตรงกัน</div><div class="wpx-100">${data_alert.diff_anount}</div></div>
        <div class="d-flex justify-content-center"><div class="wpx-180">ยอดที่ยกไป</div><div class="wpx-100">${toFixed(data_alert.total_forward)}</div></div>
        </div>
        `,
      showCancelButton: true,
      confirmButtonText: "บันทึก",
      cancelButtonText: "ยกเลิก",
    }).then(async (re) => {
      if (re.isConfirmed) {
        loading(true);
        let data = {
          data: this.state.data_bookbank.map((e, i) => ({
            bookbank_id: e.bookbank_id || "",
            remark: e.remark || "",
            date: e.date,
            time: e.time,
            income: Number(e.income),
            outcome: Number(e.outcome),
            balance: Number(e.balance),
            iw_number: e.iw_number,
            status: e.status,
            record_name: e.record_name,
            seq: i + 1,
          })),
        };
        let result = await POST(tokens, "v1/TH/statement/create-update/" + getStorage("project_id"), data);
        if (this.state.data_bookbank_remove.length) {
          await Promise.all(this.state.data_bookbank_remove.map((e) => DELETE(tokens, "v1/TH/statement/delete/" + e, null)));
        }
        loading(false);
        if (result?.status) success_url("/statement");
      }
    });
  };

  DeleteAll = () => {
    Swal.fire({
      icon: "info",
      title: "ลบข้อมูล",
      text: "ยืนยันการลบข้อมูลทั้งหมดหรือไม่",
      showCancelButton: true,
      confirmButtonText: "ลบข้อมูล",
      cancelButtonText: "ยกเลิก",
    }).then(async (re) => {
      if (re.isConfirmed) {
        loading(true);
        await Promise.all(this.state.data_bookbank.filter(e => e.bookbank_id).map((e) => DELETE(tokens, "v1/TH/statement/delete/" + e.bookbank_id, null)));
        loading(false);
        success_url("/statement");
      }
    });
  };

  handleInputEnter = (event, index, isTime = false) => {
    if (event.key === "Enter") {
      event.preventDefault();
      let { data_bookbank } = this.state;
      let isLast = isTime ? data_bookbank.length === index : data_bookbank.length * 2 === index;
      
      if (isLast) {
        data_bookbank.push(this.getNewRow());
        this.setState({ save: false, data_bookbank: this.updateBalances(data_bookbank) });
      }
      setTimeout(() => {
        const nextInput = isTime ? this.timeRefs[index + 1] : this.inputRefs[index + 1];
        if (nextInput) nextInput.focus();
      }, 100);
    }
  };

  Sheet = () => {
    let result = generateObjects(this.state.currentSheet_current).filter(item => item["IW"] !== "ข้อมูลตัวอย่าง");
    let data = result
      .filter((item) => item["วันที่"])
      .map((item) => {
        let day = String(item["วันที่"]).padStart(2, "0");
        let month = String(item["เดือน"]).padStart(2, "0");
        let year = String(item["ปี (พ.ศ.)"]);
        let timeStr = item["เวลา"] ? item["เวลา"].replaceAll(".", ":") : "";
        
        if (timeStr && !/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(timeStr)) {
          alert("warning", "แจ้งเตือน", 'รูปแบบ "เวลา" ไม่ถูกต้อง');
          return null;
        }

        return {
          date: format_date(`${year < 2100 ? year : year - 543}-${month}-${day}`, "yyyy-mm-dd", "en"),
          time: timeStr,
          income: item["เงินเข้า"] ? Number(toFixed(Number(item["เงินเข้า"])).replaceAll(",", "")) : 0,
          outcome: item["เงินออก"] ? Number(toFixed(Number(item["เงินออก"])).replaceAll(",", "")) : 0,
          balance: 0,
          iw_number: item["IW"] || "",
          status: item["สถานะ"] || "2",
          record_name: [{ name: getStorage("full_name"), status: "2", record_time: format_date(new Date(), "yyyy-mm-dd", "en") }],
        };
      }).filter(Boolean);
      
    this.setState({ data_bookbank: this.updateBalances(data), save: false });
  };

  import_file = (e) => {
    readFile(e.target.files[0])
      .then((readedData) => {
        this.setState({ import_current: readedData });
        setTimeout(() => this.Sheet(), 100);
      })
      .catch((error) => console.error(error));
    e.target.value = "";
  };

  onDragStart = (index) => this.setState({ draggedIndex: index });
  onDragOver = (e) => e.preventDefault();
  onDrop = (dropIndex) => {
    const { data_bookbank, draggedIndex } = this.state;
    if (draggedIndex === null || draggedIndex === dropIndex) return;

    const newRows = [...data_bookbank];
    const [draggedRow] = newRows.splice(draggedIndex, 1);
    newRows.splice(dropIndex, 0, draggedRow);

    this.setState({ data_bookbank: this.updateBalances(newRows), draggedIndex: null, save: false });
  };

  import_file_statement = async (e) => {
    loading(true);
    if (!e.target.files?.length) {
      loading(false);
      return;
    }

    try {
      const images = await this.processFile(e.target.files[0]);
      const array_page = images.map((i) => Tesseract.recognize(i, "eng"));
      const data = await Promise.all(array_page);
      
      let a1 = [];
      const datetimeRegex = /^(\d{2}\/\d{2}\/\d{2})(\d{1,4}:\d{2})$/;
      
      data.forEach(page => {
        page.data.text.split("\n").forEach(line => {
          let item = line.split(/\s|\|/).filter(j => j.length > 2).map(j => j.replace(/[{}\[\]()°]/g, ""));
          if (item.length === 0) return;
          
          try {
            const numberMatch = (item[0] + item[1]).match(/\d+/g);
            if (numberMatch && numberMatch.join("").length >= 5) {
              const match = datetimeRegex.exec(item[0]);
              if (match) item.splice(0, 1, match[1], match[2]);
              if (item[0].match(/^\d{6}$/)) item[0] = `${item[0].slice(0, 2)}/${item[0].slice(2, 4)}/${item[0].slice(4, 6)}`;
              if (item[0].length === 5) item[0] = "0" + item[0];
              item[0] = item[0].replace(/^(\d{2})(\d{2})\/(\d{2})$/, "$1/$2/$3").replace(/^(\d{2})\/(\d{2})(\d{2})$/, "$1/$2/$3");
              
              if (/^\d{7}$/.test(item[0]) && item[0][4] === "7") item[0] = (item[0].slice(0, 4) + item[0].slice(5)).replace(/^(\d{2})(\d{2})(\d{2})$/, "$1/$2/$3");
              if (/^\d{8}$/.test(item[0])) item[0] = (item[0].slice(0, 2) + item[0].slice(3, 5) + item[0].slice(6, 8)).replace(/^(\d{2})(\d{2})(\d{2})$/, "$1/$2/$3");

              if (item[1].includes(":")) {
                let parts = item[1].split(":");
                if (Number(parts[0]) > 100) item[1] = `${Number(parts[0]).toString().slice(-2).padStart(2, "0")}:${parts[1] || "00"}`;
              } else if (item[1].length === 4) item[1] = `${item[1].slice(0, 2)}:${item[1].slice(2, 4)}`;
              else if (item[1].length === 3) item[1] = `${item[1].slice(0, 2)}:${item[1].slice(2)}0`;
              else if (item[1].length === 5) item[1] = item[1].replaceAll(".", ":");

              if (item[0].includes("/")) {
                let amounts = item.filter(am => am.includes(",") || am.includes("."));
                let amount = amounts.length >= 2 ? amounts[amounts.length === 3 && !amounts[2].split(".")[0] ? 0 : (amounts.length === 3 ? 1 : 0)].match(/^[\d,.]+/)[0] : "";
                let total_amount = amounts.length >= 2 ? (amounts.length === 3 && !amounts[2].split(".")[0] ? amounts[1].match(/^[\d,.]+/)[0] + amounts[2] : amounts[amounts.length - 1].match(/^[\d,.]+/)[0]) : "";

                a1.push({
                  transfer_date: item[0],
                  transfer_time: item[1],
                  amount,
                  total_amount: total_amount.includes(".") ? (total_amount.slice(-1) === "." ? total_amount + "00" : total_amount) : total_amount + ".00",
                  transfer_type: "",
                });
              }
            }
          } catch (e) {}
        });
      });
      this.setState({ data_statement: a1 });
    } catch (err) {
      console.error("Error:", err);
    }
    e.target.value = "";
    loading(false);
  };

  processFile = async (file) => {
    if (!file) return Promise.reject("No file provided");
    const fileType = file.type;

    if (fileType === "application/pdf") {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = async function () {
          try {
            const pdf = await pdfjsLib.getDocument({ data: new Uint8Array(this.result) }).promise;
            const imageUrls = [];
            for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
              const page = await pdf.getPage(pageNum);
              const viewport = page.getViewport({ scale: 3 });
              const canvas = document.createElement("canvas");
              canvas.width = viewport.width;
              canvas.height = viewport.height;
              await page.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
              imageUrls.push(canvas.toDataURL("image/png"));
            }
            resolve(imageUrls);
          } catch (err) { reject("Error processing PDF"); }
        };
        fileReader.onerror = () => reject("Error reading PDF");
        fileReader.readAsArrayBuffer(file);
      });
    } else if (fileType.startsWith("image/")) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve([reader.result || ""]);
        reader.onerror = () => reject("Error reading image");
        reader.readAsDataURL(file);
      });
    }
    return Promise.reject("Unsupported file type");
  };

  getStatusText = (status) => {
    const statuses = { "1": "ฝากประจำวัน", "2": "เงินที่ลูกค้าโอน", "3": "รอออกใบเสร็จ", "4": "เช็ค กคช.", "5": "ตัดเช็ค คชจ.", "6": "จัดประโยชน์", "7": "บังคับคดี", "8": "ถอนเงิน" };
    return statuses[status] || "";
  };

  render() {
    let { data_statement, data_bookbank, filter_date, data_iw, start_date_statement, select_bookbank, disabled, draggedIndex, balance_forward, save, tab1, tab2, tab3, modal_remark, remark, bookbank_index } = this.state;
    
    // คำนวณล่วงหน้าเพื่อ Performance ของตาราง Export
    const filteredBB3 = data_bookbank.filter(e => e.status === "3");
    const filteredIW = data_iw.filter(e => new Date(e?.record_date).getTime() - new Date(e?.transfer_date).getTime() > 3 * 24 * 60 * 60 * 1000 || !data_bookbank.map(b => b.iw_number).includes(e?.iw_number));
    const exportSomeData = data_bookbank.length <= data_iw.length ? filteredIW : filteredBB3;

    if (!start_date_statement) {
      return (
        <div className="w-100 min-vh-100 fade-in">
          <Navbar page1="หน้าหลัก" page2="บันทึกรายการ statement" />
          <div className="body">
            <div className="w-100 min-vh-100 d-flex justify-content-center align-items-center">
              <div className="text-center">
                <h3 className="fw-bold">ไม่สามารถใช้งานได้</h3>
                <label>ยังไม่ได้ตั้งค่า เดือน/ปีเริ่มต้น รายการ Statement</label><br /><br />
                <button className="btn btn-primary px-4" onClick={() => window.location.href = "/manage-water"}>ไปหน้าตั้งค่า</button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="บันทึกรายการ statement" />
        <div className="body">
          <div className="p-3 pb-5">
            <div className="w-100 mb-5">
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-wrap mx-0 align-items-center w-100 mb-3">
                  <h4 className="fw-bold mb-0 mr-3">บันทึกรายการ statement</h4>
                  <input
                    type="month"
                    className="form-control wpx-200"
                    onChange={(e) => {
                      this.setState({ filter_date: e.target.value });
                      setTimeout(() => this.Get(), 100);
                    }}
                    value={filter_date}
                    disabled={!save}
                  />
                </div>
                <div className="d-flex">
                  <button className="btn btn-warning px-5 text-nowrap mr-3" onClick={() => document.getElementById("file_statement").click()}>นำเข้า statement</button>
                  <input className="d-none" type="file" id="file_statement" onChange={this.import_file_statement} />
                  <div>
                    <button className="btn btn-primary px-5 text-nowrap" onClick={() => document.getElementById("file").click()}>นำเข้า bookbank</button><br />
                    <a href={excel_file} download="template นำเข้า bookbank.xlsx">template นำเข้า bookbank.xlsx</a>
                    <input className="d-none" type="file" id="file" accept=".xls,.xlsx" onChange={this.import_file} />
                    <div className="d-none">
                      <ReactExcel initialData={this.state.import_current} onSheetUpdate={(s) => this.setState({ currentSheet_current: s })} activeSheetClassName="d-none" reactExcelClassName="table table-borderless table-striped" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex mb-2">
                <button className="btn btn-dark px-3 text-nowrap mr-3" onClick={() => document.getElementById("export_excel_some").click()}>Export Excel ข้อมูลที่ผิดพลาด</button>
                <DownloadTableExcel filename={`รายการการบันทึกข้อมูล Bookbank ที่ต้องตรวจสอบ`} sheet={`รายการ`} currentTableRef={this.tableRefSome.current}>
                  <button className="d-none" id="export_excel_some"></button>
                </DownloadTableExcel>
                
                <button className="btn btn-dark px-3 text-nowrap mr-3" onClick={() => document.getElementById("export_excel_all").click()}>Export Excel ข้อมูลทั้งหมด</button>
                <DownloadTableExcel filename={`รายงานการบันทึกข้อมูล BookBank ทังหมด`} sheet={`รายงาน`} currentTableRef={this.tableRefAll.current}>
                  <button className="d-none" id="export_excel_all"></button>
                </DownloadTableExcel>
                
                <button className="btn btn-dark px-3 text-nowrap mr-3" onClick={() => document.getElementById("export_excel_bookbank").click()}>Export Excel Book Bank</button>
                <DownloadTableExcel filename={`รายงานการบันทึกข้อมูล BookBank`} sheet={`รายงาน`} currentTableRef={this.tableRefBookBank.current}>
                  <button className="d-none" id="export_excel_bookbank"></button>
                </DownloadTableExcel>
              </div>

              <div className="d-flex mb-2">
                {[{ key: 'tab1', label: 'Statement' }, { key: 'tab2', label: 'Book bank' }, { key: 'tab3', label: 'การนำส่งเงิน' }].map(tab => (
                  <div key={tab.key} className={`card mr-2 pointer ${this.state[tab.key] ? "bg-primary text-white" : ""}`} onClick={() => this.setState({ [tab.key]: !this.state[tab.key] })}>
                    <div className="px-3 py-1 d-flex">
                      <input className="mr-2" type="checkbox" checked={this.state[tab.key]} readOnly /> {tab.label}
                    </div>
                  </div>
                ))}
              </div>

              <div className="card border-0 p-3 mb-3">
                <div className="w-100 d-flex overflow-scroll align-items-start">
                  
                  {/* TAB 1: Statement */}
                  {tab1 && (
                    <div className="me-3" style={{ minWidth: "30%" }}>
                      <table className="table table-bordered table-hover mb-0">
                        <thead>
                          <tr className="border-0" style={{ height: 46 }}><td colSpan={3} className="border-0 align-middle"><h5 className="mb-1 fw-bold">Statement</h5></td></tr>
                          <tr style={{ height: 46 }}>
                            <td colSpan={3} className="border-0 align-middle">
                              <div className="d-flex align-items-center">
                                <label className="wpx-80 mb-0">รวม</label>
                                <h4 className="mb-0 fw-bold">฿{data_statement[data_statement.length - 1]?.total_amount || "0.00"}</h4>
                              </div>
                            </td>
                          </tr>
                          <tr style={{ height: 46 }}>
                            <th className="text-nowrap px-1 sticky-top bg-white align-middle">วันเวลาที่โอนเงิน</th>
                            <th className="text-nowrap px-1 text-right sticky-top bg-white align-middle">ยอดเงิน</th>
                            <th className="text-nowrap px-1 text-right sticky-top bg-white align-middle">ยอดเงินคงเหลือ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data_statement.map((item, i) => (
                            <tr key={"data" + i} style={{ height: 46 }}>
                              <td className="text-nowrap px-1 align-middle">{item.transfer_date} {item.transfer_time.slice(0, 5) || ""}</td>
                              <td className="text-nowrap px-1 text-right align-middle">{item.amount}</td>
                              <td className="text-nowrap px-1 text-right align-middle">{item.total_amount}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {/* TAB 2: Book bank */}
                  {tab2 && (
                    <div className="me-3 flex-grow-1">
                      <table className="table table-bordered table-hover mb-0">
                        <thead>
                          <tr className="border-0" style={{ height: 46 }}>
                            <td colSpan={11} className="border-0 align-middle">
                              <div className="d-flex">
                                <h5 className="mb-0 fw-bold">Book bank</h5>
                                <a className="text-danger px-4 hpx-20 mr-3 pointer" onClick={this.DeleteAll}>ลบทั้งหมด</a>
                              </div>
                            </td>
                          </tr>
                          <tr style={{ height: 46 }}>
                            <td colSpan={11} className="border-0 align-middle">
                              <div className="d-flex align-items-center">
                                ยอดยกมา: <h5 className="mx-2 mb-0">{toFixed(balance_forward)}</h5> บาท
                                <label className="wpx-100 ms-3 mb-0">ยอดเงินคงเหลือ</label>
                                <h4 className="mb-0 fw-bold">฿{toFixed(data_bookbank[data_bookbank.length - 1]?.balance || 0)}</h4>
                              </div>
                            </td>
                          </tr>
                          <tr style={{ height: 46 }}>
                            {['', '', 'หมายเหตุ', 'ผู้บันทึก', 'IW', 'สถานะ', 'วันที่', 'เวลา', 'เงินเข้า', 'เงินออก', 'คงเหลือ'].map((th, i) => (
                              <th key={i} className={`text-nowrap sticky-top bg-white align-middle ${i >= 8 ? 'text-right' : ''}`}>{th}
                                {th === 'IW' && <span className="icon text-secondary ml-1 pointer" title="กดเลือกรายการด้านขวา">{"\uf05a"}</span>}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {data_bookbank.map((item, i) => (
                            <tr
                              key={"statement" + i}
                              draggable={!disabled}
                              onDragStart={() => this.onDragStart(i)}
                              onDragOver={this.onDragOver}
                              onDrop={() => this.onDrop(i)}
                              style={{ height: 46, cursor: "move", backgroundColor: i === draggedIndex ? "#f0f0f0" : "white" }}
                              className={item.iw_number ? "bg-white" : "bg-success-light"}
                            >
                              <td className="px-1 align-middle text-center">{!disabled && <label className="icon text-secondary pointer mb-0">{"\uf0c9"}</label>}</td>
                              <td className="px-1 align-middle">
                                {!disabled && (
                                  <label className="wpx-24 hpx-24 mb-0 bg-danger-light rounded-1 d-flex align-items-center justify-content-center">
                                    <label className="icon mx-2 text-danger pointer mb-0" onClick={() => {
                                      Swal.fire({
                                        icon: "warning", title: "ยืนยันการลบข้อมูล", text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่",
                                        showCancelButton: true, confirmButtonText: "ลบข้อมูล", cancelButtonText: "ยกเลิก", cancelButtonColor: "#d33"
                                      }).then((result) => {
                                        if (result.isConfirmed) {
                                          if (item.bookbank_id) this.state.data_bookbank_remove.push(item.bookbank_id);
                                          data_bookbank.splice(i, 1);
                                          this.setState({ data_bookbank: this.updateBalances(), save: false });
                                        }
                                      });
                                    }}>{"\uf2ed"}</label>
                                  </label>
                                )}
                              </td>
                              <td className="p-0 ps-2 align-middle">
                                <div className="d-flex align-items-center h-100">
                                  <p className="w-100 mb-0" style={{ maxWidth: 150, maxHeight: 45, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.remark || " "}</p>
                                  <label className="icon mx-2 text-warning pointer mb-0" onClick={() => this.setState({ modal_remark: true, remark: item.remark, bookbank_index: i })}>{"\uf044"}</label>
                                </div>
                              </td>
                              <td className="align-middle text-nowrap">{item.record_name[item.record_name.length - 1]?.name || ""}</td>
                              <td className="p-0 align-middle">
                                {!disabled && (
                                  item.iw_number ? (
                                    <div className="d-flex w-100 h-100 align-items-center justify-content-between px-1">
                                      <div className="text-nowrap">{item.iw_number}</div>
                                      <label className="icon mx-2 text-danger pointer mb-0" onClick={() => {
                                        data_bookbank[i].iw_number = "";
                                        this.setState({ data_bookbank, save: false });
                                      }}>{"\uf2ed"}</label>
                                    </div>
                                  ) : (
                                    <div className={`w-100 h-100 pointer p-1 d-flex align-items-center justify-content-center ${select_bookbank === i ? "bg-success text-light" : "text-secondary"}`} onClick={() => this.setState({ select_bookbank: select_bookbank === i ? -1 : i })}>
                                      {select_bookbank === i ? "กรุณาเลือก" : "ไม่ได้เลือก"}
                                    </div>
                                  )
                                )}
                              </td>
                              <td className="p-0 align-middle">
                                <select className="form-control border-0 bg-transparent w-100 p-1" value={item.status} disabled={disabled} onChange={(e) => {
                                  data_bookbank[i].status = e.target.value;
                                  this.setState({ data_bookbank, save: false });
                                }}>
                                  <option value=""></option>
                                  <option value="1">ฝากประจำวัน</option><option value="2">เงินที่ลูกค้าโอน</option>
                                  <option value="3">รอออกใบเสร็จ</option><option value="4">เช็ค กคช.</option>
                                  <option value="5">ตัดเช็ค คชจ.</option><option value="6">จัดประโยชน์</option>
                                  <option value="7">บังคับคดี</option><option value="8">ถอนเงิน</option>
                                </select>
                              </td>
                              <td className="p-0 align-middle">
                                <input type="date" className="form-control border-0 bg-transparent w-100 p-1" value={item.date} disabled={disabled} onChange={(e) => {
                                  data_bookbank[i].date = e.target.value;
                                  this.setState({ data_bookbank, save: false });
                                }} />
                              </td>
                              <td className="p-0 align-middle">
                                <input type="time" className="form-control border-0 bg-transparent w-100 text-right p-1" value={item.time} ref={el => this.timeRefs[i] = el} disabled={disabled} onKeyUp={(e) => this.handleInputEnter(e, i, true)} onChange={(e) => {
                                  data_bookbank[i].time = e.target.value;
                                  this.setState({ data_bookbank, save: false });
                                }} />
                              </td>
                              <td className="p-0 align-middle">
                                <input type="text" className="form-control border-0 bg-transparent w-100 text-right p-1" placeholder="0.00" value={item.income} ref={el => this.inputRefs[i * 2 + 1] = el} disabled={disabled} onKeyUp={(e) => this.handleInputEnter(e, i * 2 + 1)} onChange={(e) => {
                                  if (!float(e.target.value)) return;
                                  data_bookbank[i].income = e.target.value.startsWith("0") ? e.target.value.slice(1) : e.target.value;
                                  this.setState({ data_bookbank: this.updateBalances(), save: false });
                                }} />
                              </td>
                              <td className="p-0 align-middle">
                                <input type="text" className="form-control border-0 bg-transparent w-100 text-right p-1" placeholder="0.00" value={item.outcome} ref={el => this.inputRefs[i * 2 + 2] = el} disabled={disabled} onKeyUp={(e) => this.handleInputEnter(e, i * 2 + 2)} onChange={(e) => {
                                  if (!float(e.target.value)) return;
                                  data_bookbank[i].outcome = e.target.value.startsWith("0") ? e.target.value.slice(1) : e.target.value;
                                  this.setState({ data_bookbank: this.updateBalances(), save: false });
                                }} />
                              </td>
                              <td className="text-right align-middle">{toFixed(item.balance || 0)}</td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr className="border-0">
                            <td colSpan={11} className="border-0">
                              {!disabled && (
                                <button className="btn btn-info px-5" onClick={() => {
                                  data_bookbank.push(this.getNewRow());
                                  this.setState({ data_bookbank: this.updateBalances(), select_bookbank: data_bookbank.length - 1, save: false });
                                }}>+ เพิ่มรายการ</button>
                              )}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  )}

                  {/* TAB 3: การนำส่งเงิน */}
                  {tab3 && (
                    <div style={{ minWidth: "30%" }}>
                      <table className="table table-bordered table-hover mb-0">
                        <thead>
                          <tr className="border-0" style={{ height: 46 }}><td colSpan={7} className="border-0 align-middle"><h5 className="mb-1 fw-bold">การนำส่งเงิน</h5></td></tr>
                          <tr style={{ height: 46 }}>
                            <td colSpan={7} className="border-0 align-middle">
                              <div className="d-flex align-items-center">
                                <label className="wpx-150 mb-0">จำนวน {data_iw.length} รายการ</label>
                                <label className="wpx-80 mb-0">รวม</label>
                                <h4 className="mb-0 fw-bold">฿{toFixed(total(data_iw, "total_final") || 0)}</h4>
                              </div>
                            </td>
                          </tr>
                          <tr style={{ height: 46 }}>
                            {['วันเวลาที่โอนเงิน', 'ยอดใบเสร็จ', 'ห้องเลขที่', 'วันที่ใบเสร็จ', 'IW', 'RW', 'ประเภท'].map((th, i) => (
                              <th key={i} className={`text-nowrap px-1 sticky-top bg-white align-middle ${th === 'IW' || th === 'RW' ? 'text-center' : ''}`}>{th}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {data_iw.map((item, i) => (
                            <tr key={"data" + i} style={{ height: 46 }} className={`pointer ${data_bookbank.some(e => e.iw_number === item.iw_number) || !item.iw_number ? "" : "bg-danger text-white"}`} onClick={() => {
                              if (item.iw_number && select_bookbank !== -1) {
                                data_bookbank[select_bookbank].iw_number = item.iw_number;
                                this.setState({ data_bookbank, select_bookbank: data_bookbank[select_bookbank + 1]?.iw_number ? -1 : select_bookbank + 1, save: false });
                              }
                            }}>
                              <td className="text-nowrap px-1 align-middle">{item.transfer_date ? format_date(item.transfer_date, "dd/mm/yy") : ""} {item.transfer_time?.slice(0, 5) || ""}</td>
                              <td className="text-nowrap text-right px-1 align-middle">{item?.total_final ? toFixed(item?.total_final) : ""}</td>
                              <td className="text-nowrap px-1 align-middle">{item.address_number}</td>
                              <td className="text-nowrap px-1 align-middle">{item.record_date ? format_date(item.record_date, "dd/mm/yy") : ""}</td>
                              <td className="text-nowrap px-1 align-middle text-center">{item.iw_number}</td>
                              <td className="text-nowrap px-1 align-middle text-center">{item.rw_number}</td>
                              <td className="text-nowrap px-1 align-middle">{item.record_other_list?.[0]?.title || ""}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ตารางรายงานสำหรับ Export (ซ่อนไว้) */}
        <div className="d-none">
          <table ref={this.tableRefSome}>
            <thead>
              <tr>
                <th>วันที่โอน</th><th>IW</th><th>เงินเข้า</th><th>เงินออก</th><th>คงเหลือ</th><th>สถานะ</th><th>หมายเหตุ</th><th></th>
                <th>วันที่โอน</th><th>เวลาที่โอน</th><th>จำนวนเงิน</th><th>วันที่ออกใบเสร็จ</th><th>ห้องเลขที่</th><th>IW</th><th>RW</th><th>สถานะ</th>
              </tr>
            </thead>
            <tbody>
              {exportSomeData?.map((item, i) => {
                let bb = filteredBB3[i] || {};
                let iw = data_iw[i] || {};
                return (
                  <tr key={"export_some" + i}>
                    <td>{bb.date ? format_date(bb.date, "dd/mm/yy") : ""}</td>
                    <td>{bb.iw_number}</td>
                    <td>{bb.income}</td>
                    <td>{bb.outcome}</td>
                    <td>{bb.balance ? toFixed(bb.balance) : ""}</td>
                    <td>{this.getStatusText(bb.status)}</td>
                    <td>{bb.remark}</td>
                    <td></td>
                    <td>{iw.transfer_date ? format_date(iw.transfer_date, "dd/mm/yy") : ""}</td>
                    <td>{iw.transfer_time?.slice(0, 5) || ""}</td>
                    <td>{iw.total_final ? toFixed(iw.total_final) : ""}</td>
                    <td>{iw.record_date ? format_date(iw.record_date, "dd/mm/yy") : ""}</td>
                    <td>{iw.address_number}</td>
                    <td>{iw.iw_number}</td>
                    <td>{iw.rw_number}</td>
                    <td>
                      {new Date(iw.record_date).getTime() - new Date(iw.transfer_date).getTime() > 3 * 24 * 60 * 60 * 1000 ? "วันที่ออกใบเสร็จออกเกิน 3 วัน" + (bb.iw_number && !data_bookbank.some(e => e.iw_number === iw.iw_number) ? ", " : "") : ""}
                      {bb.iw_number && !data_bookbank.some(e => e.iw_number === iw.iw_number) ? "ไม่พบยอดโอน bookbank" : ""}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          <table ref={this.tableRefAll}>
            <thead>
              <tr>
                <th>วันที่โอน</th><th>เวลาที่โอน</th><th>IW</th><th>เงินเข้า</th><th>เงินออก</th><th>คงเหลือ</th><th>สถานะ</th><th>หมายเหตุ</th><th></th>
                <th>วันที่โอน</th><th>เวลาที่โอน</th><th>จำนวนเงิน</th><th>วันที่ออกใบเสร็จ</th><th>ห้องเลขที่</th><th>IW</th><th>RW</th><th>สถานะ</th>
              </tr>
            </thead>
            <tbody>
              {(data_bookbank.length <= data_iw.length ? data_iw : data_bookbank)?.map((item, i) => {
                let bb = data_bookbank[i] || {};
                let iw = data_iw[i] || {};
                return (
                  <tr key={"export_all" + i}>
                    <td>{bb.date ? format_date(bb.date, "dd/mm/yy") : ""}</td>
                    <td>{bb.time}</td>
                    <td>{bb.iw_number}</td>
                    <td>{bb.income}</td>
                    <td>{bb.outcome}</td>
                    <td>{bb.balance ? toFixed(bb.balance) : ""}</td>
                    <td>{this.getStatusText(bb.status)}</td>
                    <td>{bb.remark}</td>
                    <td></td>
                    <td>{iw.transfer_date ? format_date(iw.transfer_date, "dd/mm/yy") : ""}</td>
                    <td>{iw.transfer_time?.slice(0, 5) || ""}</td>
                    <td>{iw.total_final ? toFixed(iw.total_final) : ""}</td>
                    <td>{iw.record_date ? format_date(iw.record_date, "dd/mm/yy") : ""}</td>
                    <td>{iw.address_number || ""}</td>
                    <td>{iw.iw_number || ""}</td>
                    <td>{iw.rw_number || ""}</td>
                    <td>
                      {new Date(iw.record_date).getTime() - new Date(iw.transfer_date).getTime() > 3 * 24 * 60 * 60 * 1000 ? "วันที่ออกใบเสร็จออกเกิน 3 วัน" + (bb.iw_number && !data_bookbank.some(e => e.iw_number === iw.iw_number) ? ", " : "") : ""}
                      {bb.iw_number && !data_bookbank.some(e => e.iw_number === iw.iw_number) ? "ไม่พบยอดโอน bookbank" : ""}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          <table ref={this.tableRefBookBank}>
            <thead>
              <tr><th>วันที่</th><th>เดือน</th><th>ปี (พ.ศ.)</th><th>เวลา</th><th>เงินเข้า</th><th>เงินออก</th><th>IW</th><th>สถานะ</th><th>หมายเหตุ</th></tr>
            </thead>
            <tbody>
              {data_bookbank.map((item, i) => (
                <tr key={"export_bb" + i}>
                  <td>{item.date ? format_date(item.date, "dd", "th") : ""}</td>
                  <td>{item.date ? format_date(item.date, "mm", "th") : ""}</td>
                  <td>{item.date ? format_date(item.date, "yyyy", "th") : ""}</td>
                  <td>{item.time || ""}</td>
                  <td>{item.income || 0}</td>
                  <td>{item.outcome || 0}</td>
                  <td>{item.iw_number || ""}</td>
                  <td>{this.getStatusText(item.status)}</td>
                  <td>{item.remark || ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {!save && (
          <div className="w-100 bg-white p-3 position-fixed d-flex justify-content-end" style={{ bottom: 0, zIndex: 10 }}>
            <button className="btn btn-primary px-5" onClick={this.CreateUpdate}>บันทึกข้อมูล</button>
          </div>
        )}

        <Modal show={modal_remark} onHide={() => this.setState({ modal_remark: false })}>
          <Modal.Header><Modal.Title><b>แก้ไขหมายเหตุ</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex align-items-center mb-3">
              <label className="wpx-100">หมายเหตุ:</label>
              <textarea className="form-control bg-contain border-0" placeholder="พิมพ์คำค้นหา..." onChange={(e) => this.setState({ remark: e.target.value })} value={remark} />
            </div>
            <div className="w-100 d-flex">
              <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_remark: false })}>ยกเลิก</button></div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={() => {
                  data_bookbank[bookbank_index].remark = remark;
                  this.setState({ data_bookbank, modal_remark: false, save: false });
                }}>ยืนยัน</button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}